// Star rating glyphs. A row of stars is parsed at a glance where "4/5" has to be read, so this is
// the default way to show a rating anywhere a shopper is mid-decision.
//
// `value` fills that many and outlines the rest. That matters on a list of individual reviews: a
// four-star entry has to look different from a five-star one, or the row of stars says nothing.

import { StarIcon } from "@/components/ui/StarIcon";

export function Stars({
  className = "h-3.5 w-3.5",
  value = 5,
  outOf = 5,
}: {
  className?: string;
  /** How many stars are filled. Rounded, so 4.5 shows as 5 filled. */
  value?: number;
  outOf?: number;
}) {
  const filled = Math.round(value);
  return (
    <span aria-hidden="true" className="flex items-center gap-0.5">
      {Array.from({ length: outOf }, (_, i) => (
        <StarIcon
          className={`${className} ${i < filled ? "fill-gold text-gold" : "fill-none text-rule-strong"}`}
          key={i}
          strokeWidth={1.5}
        />
      ))}
    </span>
  );
}
